import { APIEndpoint, APIStatus } from "enums";
import log from "logger";
import auth from "managers/auth";
import content from "managers/content";
import data from "managers/data/data";
import ga from "managers/ga";
import appIcons from "managers/icons";
import modal from "managers/modals";
import net from "managers/net";
import relics from "managers/relics";
import { actions, store } from "managers/state";
import sysMsg from "managers/sysMsg";
import type { GetNotices } from "managers/types/net-types";
import view from "managers/view/view";
import type { AppManagers } from "types/site";

const manager:AppManagers = {
	init: managerInit,
	auth: auth,
	data: data,
	view: view,
	request: net,
	relics: relics,
	content: content,
	modal: modal,
	icons: appIcons,
	ga: ga,
};
export default manager;

async function managerInit():Promise<void>{
	log.status("Initialisation Start");

	ga.init();
	net.init();
	relics.init();
	initNotices();

	/* Do auth init & data last */
	await auth.init();
	const isDataSetup = await data.init();
	if(!isDataSetup){
		log.status("Unable to setup data");
		sysMsg.error({
			title: "Error preparing data",
			message: "Refresh the page and try again, if the problem persists get in contact",
		}, 0);
	}
	log.status("Initialisation Completed");
}

function initNotices():void{
	const interval = 60 * 60 * 1000; // 1hr
	setInterval(fetchNotices, interval);
	fetchNotices();
}

async function fetchNotices():Promise<void>{
	const result = await manager.request.send<GetNotices.Request, GetNotices.Response>(APIEndpoint.GET_NOTICES, {});
	if(!result){ return; }

	if(result.status === APIStatus.SUCCESS){
		store.dispatch(actions.setNotices(result.data.notices));
	}
}
